import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const SBN_URL = `${API_URL}/subscription-banner`;

const listSubscriptionBanner = () => {
  return axios.get(`${SBN_URL}/list`).then((response) => {
    return response;
  });
};

const createSubscriptionBanner = (formData: FormData) => {
  return axios.post(`${SBN_URL}/create`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => {
    return response;
  });
};

const updateSubscriptionBanner = (formData: FormData, id: any) => {
  return axios.put(`${SBN_URL}/update/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response) => {
    return response;
  });
};

const viewSubscriptionBanner = (id: any) => {
  return axios.get(`${SBN_URL}/view/${id}`).then((response) => {
    return response;
  });
};

const deleteSubscriptionBanner = (id: any, userId: number) => {
  return axios.delete(`${SBN_URL}/delete/${id}`, { data: { userId } }).then((response) => {
    return response;
  });
};

const updateBannerStatus = (id: any, data: any) => {
  return axios.patch(`${SBN_URL}/update-status/${id}`, data);
};

export {
  listSubscriptionBanner,
  createSubscriptionBanner,
  updateSubscriptionBanner,
  viewSubscriptionBanner,
  deleteSubscriptionBanner,
  updateBannerStatus,
};
